module.exports = __webpack_public_path__ + "media/images/front/icons/chat-a5eb031d9d186340fcdd21dcfe0dc505.svg";